<template>
  <div class="border rounded">
    <table :class="loading ? 'disable table' : 'table'">
      <thead>
        <tr>
          <td colspan="4">
            <div
              class="d-flex"
              style="align-items: center; justify-content: flex-end"
            >
              <select
                class="form-control border p-1"
                style="max-width: 15rem"
                v-model.number="selectedClient"
              >
                <option
                  v-for="client in allClients"
                  :key="client.id"
                  :value="client.id"
                >
                  {{ client.name }}
                </option>
              </select>
              <button
                type="button"
                class="btn btn-primary btn-sm ml-1"
                @click="copyProductIndex"
              >
                Copy
              </button>
            </div>
          </td>
        </tr>
        <tr>
          <th scope="col" class="w-10">Exclude</th>
          <th scope="col" class="w-70">Name</th>
          <th scope="col" class="w-10">Profit Margin</th>
          <th scope="col" class="w-10">Notes</th>
        </tr>
      </thead>

      <tbody>
        <template v-for="ch0 in categoryData">
          <tr :key="ch0.categoryID">
            <td>
              <b-checkbox
                name=""
                id=""
                class="mt-2"
                v-model="ch0.checked"
                @change="
                  (e) => {
                    categoriesIncludeExcludeChange.set(
                      ch0.categoryID,
                      ch0.checked
                    );
                  }
                "
              />
            </td>
            <td>
              <font-awesome-icon
                icon="plus-square"
                class="mr-1"
                style="cursor: pointer"
                @click="appendChildL1(ch0.categoryID)"
                v-if="!categoriesOpened.includes(ch0.categoryID)"
              />
              <font-awesome-icon
                icon="minus-square"
                class="mr-1"
                style="cursor: pointer"
                @click="removeChildL1(ch0.categoryID)"
                v-if="categoriesOpened.includes(ch0.categoryID)"
              />
              <span class="mt-2" style="display: inline-block">{{
                ch0.label
              }}</span>
            </td>
            <td>
              <input
                type="number"
                name=""
                id=""
                min="0"
                style="max-width: 40%; display: inline"
                class="form-control mr-1"
                @change="(e) => changePercentageMarkup(e, ch0)"
                v-model.number="ch0.percentageMarkup"
              />%
            </td>
            <td>
              <p class="mt-2">{{ ch0.notes }}</p>
            </td>
          </tr>
          <template>
            <template v-for="ch1 in ch0.childrenCat">
              <tr
                :key="ch1.categoryID"
                style="background-color: #dfe7ff"
                v-show="categoriesOpened.includes(ch0.categoryID)"
              >
                <td>
                  <b-checkbox
                    name=""
                    id=""
                    class="mt-2"
                    v-model="ch1.checked"
                    @change="
                      (e) => {
                        categoriesIncludeExcludeChange.set(
                          ch1.categoryID,
                          ch1.checked
                        );
                      }
                    "
                  />
                </td>
                <td>
                  <font-awesome-icon
                    icon="plus-square"
                    class="ml-2 mr-1"
                    style="cursor: pointer"
                    @click="appendChildL2(ch0.categoryID, ch1.categoryID)"
                    v-if="!subCategoriesOpened.includes(ch1.categoryID)"
                  />
                  <font-awesome-icon
                    icon="minus-square"
                    class="ml-2 mr-1"
                    style="cursor: pointer"
                    @click="removeChildL2(ch1.categoryID)"
                    v-if="subCategoriesOpened.includes(ch1.categoryID)"
                  />
                  <span class="mt-2" style="display: inline-block">{{
                    ch1.label
                  }}</span>
                </td>
                <td>
                  <input
                    type="number"
                    name=""
                    id=""
                    min="0"
                    style="max-width: 40%; display: inline"
                    class="form-control mr-1"
                    @change="(e) => changePercentageMarkup(e, ch1)"
                    v-model.number="ch1.percentageMarkup"
                  />%
                </td>
                <td>
                  <p class="mt-2">{{ ch1.notes }}</p>
                </td>
              </tr>
              <template>
                <tr
                  v-for="ch2 in ch1.childrenCat"
                  :key="ch2.categoryID"
                  style="background-color: #bfcfff"
                  v-show="subCategoriesOpened.includes(ch1.categoryID)"
                >
                  <td>
                    <b-checkbox
                      name=""
                      id=""
                      class="mt-2"
                      v-model="ch2.checked"
                      @change="
                        (e) =>
                          categoriesIncludeExcludeChange.set(
                            ch2.categoryID,
                            ch2.checked
                          )
                      "
                    />
                  </td>
                  <td>
                    <span class="pl-4 mt-2" style="display: inline-block">{{
                      ch2.label
                    }}</span>
                  </td>
                  <td>
                    <input
                      type="number"
                      name=""
                      id=""
                      min="0"
                      style="max-width: 40%; display: inline"
                      class="form-control mr-1"
                      @change="(e) => changePercentageMarkup(e, ch2)"
                      v-model.number="ch2.percentageMarkup"
                    />%
                  </td>
                  <td>
                    <p class="mt-2">{{ ch2.notes }}</p>
                  </td>
                </tr>
              </template>
            </template>
          </template>
        </template>
      </tbody>
      <tfoot>
        <tr class="d-flex" style="justify-content: flex-end">
          <td>
            <button
              type="button"
              class="btn btn-primary"
              @click="updateProductIndex"
            >
              Update
            </button>
          </td>
        </tr>
      </tfoot>
    </table>
    <a-spin class="spinner" v-if="loading"></a-spin>
  </div>
</template>

<script>
import {changeCategoryExclusionForClient} from "@/api/divvy-manageClients";
export default {
  data() {
    return {
      records: [],
      categoriesOpened: [],
      subCategoriesOpened: [],
      categoryData: [],
      subCategory1Data: [],
      subCategory2Data: [],
      allClients: [],
      selectedClient: null,
      childrenToBeClosed: [],
      copyFrom: null,
      loading: false,
      categoriesIncludeExcludeChange: new Map(),
    };
  },
  methods: {
    appendChildL1(parentCategoryId) {
      this.loading = true;

      const catSelected = this.categoryData.filter(
        (ch0) => parentCategoryId === ch0.categoryID
      );

      if (catSelected[0].childrenCat !== undefined) {
        this.subCategory1Data = catSelected[0].childrenCat;
        this.categoriesOpened.push(parentCategoryId);
        this.loading = false;
        return;
      }

      this.$store
        .dispatch("manageClients/getClientCategoryTree", {
          clientID: this.selectedClient,
          parentCategoryID: parentCategoryId,
        })
        .then((data) => {
          this.subCategory1Data = data;
          catSelected[0].childrenCat = this.subCategory1Data;
          this.categoriesOpened.push(parentCategoryId);

          this.loading = false;
          // console.table(catSelected);
        });
    },
    removeChildL1(parentCategoryId) {
      this.loading = true;

      const catSelected = this.categoryData.filter(
        (ch0) => parentCategoryId === ch0.categoryID
      );

      if (catSelected[0].childrenCat !== undefined) {
        this.childrenToBeClosed = catSelected[0].childrenCat.map(
          (children) => children.categoryID
        );

        this.childrenToBeClosed.map((childId) => {
          this.subCategoriesOpened = this.subCategoriesOpened.filter(
            (openChildId) => childId !== openChildId
          );
        });
      }

      this.categoriesOpened = this.categoriesOpened.filter(
        (id) => parentCategoryId !== id
      );

      this.loading = false;
    },
    appendChildL2(parentCategoryId, childCategoryId) {
      this.loading = true;
      const catSelected = this.categoryData.filter(
        (ch0) => parentCategoryId === ch0.categoryID
      );

      const subCatSelected = catSelected[0].childrenCat.filter(
        (ch1) => childCategoryId === ch1.categoryID
      );

      if (subCatSelected[0].childrenCat !== undefined) {
        this.subCategory2Data = subCatSelected[0].childrenCat;
        this.subCategoriesOpened.push(childCategoryId);
        this.loading = false;
        return;
      }

      this.$store
        .dispatch("manageClients/getClientCategoryTree", {
          clientID: this.selectedClient,
          parentCategoryID: childCategoryId,
        })
        .then((data) => {
          this.subCategory2Data = data;
          subCatSelected[0].childrenCat = this.subCategory2Data;
          this.subCategoriesOpened.push(childCategoryId);

          this.loading = false;
          // console.table(catSelected);
        });
    },
    removeChildL2(childCategoryId) {
      this.loading = true;
      this.subCategoriesOpened = this.subCategoriesOpened.filter(
        (ch1) => ch1 !== childCategoryId
      );
      this.loading = false;
    },
    excludeCategory(e, record) {
      const parentOfCheckbox = e.target.parentElement;
      parentOfCheckbox.classList.add("bl-red");
      const recordSelected = this.records.filter(
        (rec) => rec.categoryID === record.categoryID
      );
      if (recordSelected.length === 0) {
        this.records.push(record);
      } else {
        recordSelected.checked = record.checked;
      }
    },
    copyProductIndex() {
      this.loading = true;
      this.copyFrom = this.selectedClient;
      this.$store
        .dispatch("manageClients/getClientCategoryTree", {
          clientID: this.selectedClient,
          parentCategoryID: 0,
        })
        .then((data) => {
          this.categoryData = data;
          this.loading = false;
        });
    },
    async updateProductIndex() {
      this.loading = true;

      console.log(this.categoriesIncludeExcludeChange);

      // update category Inclusions/Exclusions
      try {
       for (let [key,value] of this.categoriesIncludeExcludeChange) {
        // take note of the boolean flip for checked
          const resp = await changeCategoryExclusionForClient({clientID: this.selectedClient, categoryID: key, shouldExclude: !value})
        };
        
      }catch (e) {
        console.error(e)
      }
      finally {
        this.categoriesIncludeExcludeChange = new Map();
      }

      await this.$store.dispatch("manageClients/updateClientCategoryMapping", {
        copyFromClientID: this.copyFrom,
        copyToClientID: Number(this.$route.params.Id),
        clientModifiedRecords: this.records,
      });

      this.records = [];
      this.categoriesOpened = [];
      this.subCategoriesOpened = [];
      const data = await this.$store.dispatch(
        "manageClients/getClientCategoryTree",
        {
          clientID: Number(this.$route.params.Id),
          parentCategoryID: 0,
        }
      );

      this.categoryData = data;
      this.loading = false;

      
    },
    changePercentageMarkup(e, record) {
      const parentOfCheckbox = e.target.parentElement;
      parentOfCheckbox.classList.add("bl-red");
      const recordSelected = this.records.filter(
        (rec) => rec.categoryID === record.categoryID
      );
      if (recordSelected.length === 0) {
        this.records.push(record);
      } else {
        recordSelected.percentageMarkup = record.percentageMarkup;
      }
    },
  },
  created() {
    this.$store.dispatch("manageClients/getClients").then((data) => {
      this.allClients = data;
    });
    this.$store
      .dispatch("manageClients/getClientCategoryTree", {
        clientID: Number(this.$route.params.Id),
        parentCategoryID: 0,
      })
      .then((data) => {
        this.selectedClient = Number(this.$route.params.Id);
        this.categoryData = data;
      });
  },
};
</script>

<style scoped>
.bl-red {
  border-left: 2px solid red;
}
tbody {
  display: block;
  height: 400px;
  overflow: auto;
}
thead,
tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed; /* even columns width , fix width of table too*/
}
.disable {
  opacity: 0.5;
}
.spinner {
  position: absolute;
  left: 50%;
  top: 50%;
  translate: -50%, -50%;
}
td {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}

.mb-4 {
  margin-bottom: 32px !important;
}
</style>
